import React, { useEffect, useState } from "react";

const HeroSection = () => {
  const [clipPath, setClipPath] = useState(
    "polygon(0 0, 100% 0, 100% 70%, 0% 100%)"
  );

  useEffect(() => {
    const updateClipPath = () => {
      const isSmall = window.innerWidth < 768;
      setClipPath(
        isSmall
          ? "polygon(0 0, 100% 0, 100% 90%, 0% 100%)" // less angled for small screens
          : "polygon(0 0, 100% 0, 100% 85%, 0% 100%)"
      );
    };

    updateClipPath();
    window.addEventListener("resize", updateClipPath);
    return () => window.removeEventListener("resize", updateClipPath);
  }, []);

  return (
    <section
      className="w-full bg-[var(--primary-orange-color)] text-[var(--primary-bg-color)] text-center py-20 lg:py-36 relative font-poppins mb-[25px] lg:mb-[50px]"
      style={{
        clipPath: clipPath,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 md:pb-5">
        <h2 className="text-[28px] lg:text-[42px] xl:text-[60px] text-[var(--background-light-gray-color)] font-light mb-2 uppercase">
          Have a question?
        </h2>
        <h1 className="text-[28px] lg:text-[42px] xl:text-[60px] font-semibold mb-6">
          LET’S CONNECT
        </h1>
        <p className="text-[12px] lg:text-[18px] font-normal leading-relaxed lg:mb-[100px]">
          We’d love to hear from you! Whether you’re exploring care options,
          have a question, or just need someone to talk to, we’re only a call or
          message away. Our friendly team will get back to you as soon as
          possible to see how we can make life a little easier for you and your
          loved ones.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
